import React from 'react';
import Recete3 from '../assets/images/recete3.jpg';
import AboutHero from '../components/common/AboutHero';
import ContactStrip from '../components/common/ContactStrip';
import AboutMVG from '../components/layout/vizyon/AboutMVG';
import MegaParkLogo from '../assets/images/megapark.png';
import { toUrl } from '../lib/config';


const VizyonMisyonPage: React.FC = () => {
  const DEFAULT_HERO = {
    kicker: 'Hakkımızda',
    title: 'Biz Kimiz?',
    description: 'Sağlığınıza adanmış bir ekibiz. Deneyimli ve uzman kadromuzla hastalarımızın sağlığını koruma ve geliştirmeye odaklanıyoruz. Hasta memnuniyeti ve güveni bizim için en önemli değerlerdir.',
  };

  const [heroKicker, setHeroKicker] = React.useState<string>('');
  const [heroTitle, setHeroTitle] = React.useState<string>('');
  const [heroDesc, setHeroDesc] = React.useState<string>('');
  const [heroLoading, setHeroLoading] = React.useState<boolean>(true);
  const fetchedRef = React.useRef(false);

  // AboutMVG state + defaults
  const DEFAULT_MVG = {
    missionTitle: 'Misyonumuz',
    missionText: 'Hasta haklarına saygılı, etik ilkelere bağlı, adalet ve hakkaniyete önem veren; çevreye ve canlıya zarar vermeyen bir anlayışla hizmet veririz.',
    visionTitle: 'Vizyon',
    visionText: 'Hasta ve çalışan memnuniyetini önceleyen, modern teknoloji ve yenilikleri uygulayan, toplum sağlığına katkı sağlayan öncü bir kuruluş olmak.',
    goalsAccentTitle: 'Kurumsal',
    goalsRestTitle: 'Amaçlar ve Hedefler',
    goalsItems: [
      'Fiziksel alanların yenilenmesi ve memnuniyetin artırılması.',
      'Gebe okulu hizmetlerinin artırılması.',
      'Tüp bebek hizmetlerinde talebin artması.',
      'Marka gücünün ve erişimin genişletilmesi.',
      'Yeni tıbbi birimlerin açılması.',
      'Dijital süreçlerin hızlandırılması.',
      'Gelirlerin artırılması ve giderlerde tasarruf.',
      'Verimlilik ve maliyetlerde iyileştirme.',
    ],
    corporateAccentTitle: 'Kurumsal',
    corporateRestTitle: 'Değerler',
    corporateText: 'Hasta haklarına saygılı olmak, tıbbi etik kurallara bağlı olmak, bilgili, güvenilir ve dürüst olmak, araştırmacı, özverili, sorumluluk sahibi ve toplum yararını gözetiyor olmak, adil olmak, eşitlik ilkesini benimsemek, yeniliklere açık olmak, etkin yönetim anlayışına sahip olmak, sürdürülebilir kent politikası oluşturmak, yönetimde katılımcı yaklaşımı gözetmek, değişime uyum sağlamak, katılımcı olmak, ekip ruhu içinde işbirliği, dayanışma ve paylaşma ruhuna sahip olmak.',
    logoUrl: '',
  };

  const [mvg, setMvg] = React.useState(DEFAULT_MVG);
  const mvgFetchedRef = React.useRef(false);

  React.useEffect(() => {
    let cancelled = false;
    if (fetchedRef.current) return; // StrictMode'da ikinci defa çalışmayı engelle
    fetchedRef.current = true;
    const run = async () => {
      try {
        setHeroLoading(true);
        const res = await fetch(toUrl('/api/page-hero/hakkimizda'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (!cancelled) {
          setHeroKicker(obj.kicker || '');
          setHeroTitle(obj.title || '');
          setHeroDesc(obj.description || '');
        }
      } catch {
        // ignore
      } finally {
        if (!cancelled) setHeroLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  // Fetch AboutMVG content (vision-mission)
  React.useEffect(() => {
    let cancelled = false;
    if (mvgFetchedRef.current) return;
    mvgFetchedRef.current = true;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/vision-mission/vizyon-misyon'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setMvg({
          missionTitle: obj.missionTitle || DEFAULT_MVG.missionTitle,
          missionText: obj.missionText || DEFAULT_MVG.missionText,
          visionTitle: obj.visionTitle || DEFAULT_MVG.visionTitle,
          visionText: obj.visionText || DEFAULT_MVG.visionText,
          goalsAccentTitle: obj.goalsAccentTitle || DEFAULT_MVG.goalsAccentTitle,
          goalsRestTitle: obj.goalsRestTitle || DEFAULT_MVG.goalsRestTitle,
          goalsItems: Array.isArray(obj.goalsItems) && obj.goalsItems.length ? obj.goalsItems : DEFAULT_MVG.goalsItems,
          corporateAccentTitle: obj.corporateAccentTitle || DEFAULT_MVG.corporateAccentTitle,
          corporateRestTitle: obj.corporateRestTitle || DEFAULT_MVG.corporateRestTitle,
          corporateText: obj.corporateText || DEFAULT_MVG.corporateText,
          logoUrl: obj.logoUrl || DEFAULT_MVG.logoUrl,
        });
      } catch {
        // keep defaults
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      {/* <AboutHero
        image={Recete3}
        kicker="Hakkımızda"
        title="Biz Kimiz?"
        description="Sağlığınıza adanmış bir ekibiz. Deneyimli ve uzman kadromuzla hastalarımızın sağlığını koruma ve geliştirmeye odaklanıyoruz. Hasta memnuniyeti ve güveni bizim için en önemli değerlerdir. Sizin sağlığınız bizim için birinci önceliktir."
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      /> */}

      <AboutHero
        image={Recete3}
        kicker={heroKicker || DEFAULT_HERO.kicker}
        title={heroTitle || DEFAULT_HERO.title}
        description={heroDesc || DEFAULT_HERO.description}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />

      <AboutMVG
        mission={{
          title: mvg.missionTitle,
          text: mvg.missionText,
        }}
        vision={{
          title: mvg.visionTitle,
          text: mvg.visionText,
        }}
        goals={{
          accentTitle: mvg.goalsAccentTitle,
          restTitle: mvg.goalsRestTitle,
          items: mvg.goalsItems,
        }}
        corporateValues={{
          accentTitle: mvg.corporateAccentTitle,
          restTitle: mvg.corporateRestTitle,
          text: mvg.corporateText,
        }}
        logoSrc={((): string => {
          const raw = mvg.logoUrl || '';
          if (!raw) return MegaParkLogo;
          const normalized = /^https?:\/\//i.test(raw)
            ? raw
            : (raw.startsWith('/api/') ? raw : `/api/media/${raw}`);
          return toUrl(normalized);
        })()}
        accentColor="#e30613" // istersen kırmızıya (örnek görseldeki gibi)
        maxWidth={1200}
      />

      <ContactStrip />

    </>
  );
};

export default VizyonMisyonPage;
